module.exports = __webpack_public_path__ + "static/img/YD100.2a674d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YD100.png
// module id = zQYU
// module chunks = 2